<template>
    <div>
        <Header />
        <div id="account">
            <div class="container_width">
                <v-snackbar
                    :timeout="actionDuration"
                    v-model="actionDialog"
                    centered
                    top
                    elevation="20"
                    :color="actionColor"
                    class="pa-6 pt-0"
                    style="margin-top: 9%"
                >
                    <div 
                        class="text-center headline font-weight-medium"
                        :class="actionColor == 'success' ? 'primary--text text--darken-2' : 'white--text'"
                        v-html="actionMessage">
                    </div>
                </v-snackbar>

                <div class="sansation_title pg_title_color mt-6">Account Information</div>
                <p></p>
                <div id="main_wrapper" class="spacing">
                    <div id="main_panel" class="d-inline">
                        <h4 class="mt-4 mb-10 sansation subtitle_size">Primary Contact Information</h4>
                        <v-form v-model="contact_valid" ref="contact_info">                    
                            <div class="d-flex d-block mr-10">
                                <div class="d-inline mr-10" style="width: 45%">
                                    <div class="d-block sansation">First Name <span class="ml-1 red--text text-subtitle-1">*</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.first_name" 
                                        solo
                                        class="d-block"
                                        :rules="requiredField"
                                        required>
                                    </v-text-field>
                                </div>
                                <div class="d-inline ml-10" style="width: 45%">
                                    <div class="d-block sansation">Last Name <span class="ml-1 red--text text-subtitle-1">*</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.last_name" 
                                        solo
                                        class="d-block"
                                        :rules="requiredField"
                                        required>
                                    </v-text-field>
                                </div>
                            </div>

                            <div class="d-flex d-block mr-10">
                                <div class="d-inline mr-10" style="width: 45%">
                                    <div class="d-block sansation">Title <span class="ml-1 red--text text-subtitle-1">&nbsp;</span></div>
                                    <v-select 
                                        v-model="input.title"
                                        :items="titles" 
                                        label="Title" 
                                        solo
                                        class="d-block">
                                    </v-select>
                                </div>
                                <div class="d-inline ml-10" style="width: 45%">
                                    <div class="d-block sansation">Phone <span class="ml-1 red--text text-subtitle-1">*</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.phone" 
                                        solo
                                        class="d-block"
                                        :rules="requiredField"
                                        required>
                                    </v-text-field>
                                </div>
                            </div>                        

                            <div class="d-flex d-block mr-10">
                                <div class="d-inline mr-10" style="width: 45%">
                                    <div class="d-block sansation">Company <span class="ml-1 red--text text-subtitle-1">&nbsp;</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.company" 
                                        solo
                                        class="d-block">
                                    </v-text-field>
                                </div>
                                
                                <div class="d-inline ml-10" style="width: 45%">
                                    <div class="d-block sansation">Website <span class="ml-1 red--text text-subtitle-1">&nbsp;</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.website" 
                                        solo 
                                        class="d-block">
                                    </v-text-field>                                    
                                </div>
                            </div>

                            <div class="d-flex d-block mr-10">
                                <div class="d-inline mr-10" style="width: 45%">
                                    <div class="d-block sansation">Mailing Address <span class="ml-1 red--text text-subtitle-1">*</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.address" 
                                        solo
                                        class="d-block"
                                        :rules="requiredField"
                                        required>
                                    </v-text-field>
                                </div>
                                <div class="d-inline ml-10" style="width: 45%">
                                    <div class="d-block sansation">Second Address Line <span style="font-size:small">[Optional Suite, Apt., etc.]</span><span class="ml-1 red--text text-subtitle-1">&nbsp;</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.address2" 
                                        solo
                                        class="d-block">
                                    </v-text-field>
                                </div>
                            </div>

                            <div class="d-flex d-block mr-10">
                                <div class="d-inline mr-4" style="width: 45%">
                                    <div class="d-block sansation">City <span class="ml-1 red--text text-subtitle-1">*</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.city" 
                                        solo
                                        class="d-block"
                                        :rules="requiredField"
                                        required>
                                    </v-text-field>
                                </div>
                                <div class="d-inline mr-4" style="width: 35%">
                                    <div class="d-block sansation">State <span class="ml-1 red--text text-subtitle-1">*</span></div>
                                    <v-select 
                                        v-model="input.state"
                                        :items="states" 
                                        label="State" 
                                        solo
                                        class="d-block"
                                        :rules="requiredField"
                                        required>
                                    </v-select>
                                </div>
                                <div class="d-inline" style="width: 20%">
                                    <div class="d-block sansation">Zip Code <span class="ml-1 red--text text-subtitle-1">*</span></div>
                                    <v-text-field 
                                        v-model.lazy="input.postal" 
                                        solo
                                        class="d-block"
                                        :rules="requiredField"
                                        required>
                                    </v-text-field>
                                </div>
                            </div>
                            
                            <div class="d-block my-4 mr-10">
                                <v-btn 
                                    color="primary" 
                                    dark
                                    @click="updateContact">
                                    Change Contact Info
                                </v-btn>
                            </div>
                        </v-form>
                    </div>
                    <div id="right_panel" class="d-inline pl-12">
                        <h4 class="mt-4 mb-10 ml-12 sansation subtitle_size d-block text-left">Change Your Password</h4>
                        <v-form v-model="cred_valid" ref="login_credentials">                        
                            <div class="d-block text-right ml-12">
                                <div class="d-block sansation text-left">Password</div>
                                <v-text-field 
                                    v-model.lazy="input.password" 
                                    solo
                                    clearable
                                    class="d-block"
                                    :append-icon="show_eye1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show_eye1 ? 'text' : 'password'" 
                                    @click:append="show_eye1 = !show_eye1"
                                    :hint="input.password != null ? '' : `This field is required to change your password.`"
                                    :persistent-hint="input.password != null ? false : true"
                                    :rules="passRules"
                                    required>
                                </v-text-field>                                    
                            </div>

                            <div class="d-block text-right ml-12">
                                <div class="d-block sansation text-left">Confirm Password</div>
                                <v-text-field 
                                    v-model.lazy="input.confirm_password" 
                                    solo 
                                    clearable
                                    class="d-block"
                                    :append-icon="show_eye2 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show_eye2 ? 'text' : 'password'" 
                                    @click:append="show_eye2 = !show_eye2"
                                    :hint="input.confirm_password != null ? '' : `This field is required to change your password.`"
                                    :persistent-hint="input.confirm_password != null ? false : true"
                                    :rules="cpassRules"
                                    required>
                                </v-text-field>
                            </div>
                            
                            <div class="d-block my-4 text-right">
                                <v-btn 
                                    color="primary" 
                                    dark
                                    @click="changeLogin">
                                    Change Password
                                </v-btn>
                            </div>
                        </v-form>

                        <h4 class="mt-12 mb-10 ml-12 pt-12 sansation subtitle_size d-block text-left">Change Your Username/Email</h4>
                        <v-form v-model="email_valid" ref="email_username">                        
                            <div class="d-block text-right ml-12">
                                <div class="d-block sansation text-left">Username / Email</div>
                                <v-text-field 
                                    v-model.lazy="input.user_email" 
                                    solo 
                                    class="d-block"
                                    hint="Changing your email address also changes your login username."
                                    persistent-hint
                                    :rules="emailRules"
                                    required>
                                </v-text-field>                                
                            </div>
                            
                            <div class="d-block my-4 text-right">
                                <v-btn 
                                    color="primary" 
                                    dark
                                    @click="updateEmail">
                                    Change Username
                                </v-btn>
                            </div>
                        </v-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';

    import Header from './Header'

    export default {
        name: 'Account',
        components: {
            Header
        },

        data () {
            return {
                input: {
                    first_name: '',
                    last_name: '',
                    phone: '',
                    address: '',
                    address2: '',
                    city: '',
                    state: '',
                    postal: '',
                    title: '',
                    company: '',
                    website: '',
                    user_email: '',
                    password: '',
                    confirm_password: '',
                },
                actionDialog: false,
                actionMessage: '',
                actionColor: 'error',
                actionDuration: 6000,
                contact_valid: false,
                cred_valid: false,
                email_valid: false,
                states: [],
                titles: [],
                outcome_type: 'success',
                lockout_value: 0,
                show_eye1: false,
                show_eye2: false,
                requiredField: [
                    (v) => !!v || 'Field is required'
                ],
                passRules: [
                    (v) => v == undefined || '' || (v != undefined && v.length >= 14 || 'Password must be 14 characters long')
                ],
                cpassRules: [
                    (v) => v == undefined || '' || ((v != undefined && (this.input.password != '' && v == this.input.password)) || 'Confirmation does not match Password')
                ],
                emailRules: [
                    (v) => !!v || 'Email is required',
                    (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(v) || 'Email must be in valid format'
                ],
            }
        },
        
        watch: {
            // user_email: function (mail) {
            //     this.emailRules = [ v => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/.test(v) || 'Email must be in valid format' ]
            // }
        },

        created () {
        	document.title = 'SRG myCompass: Account Information'
    	},

        mounted() {
            this.getAccount();
            this.getLists();
        },

        methods: {
            getAccount: function () {
                axios.get(`${appUrls.api}/api/account/${Cookie.get('id')}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    if(res.data.outcome){
                        //console.log(res.data.contact);
                        this.input = res.data.contact;
                        this.lockout_value = res.data.contact.lockout;
                        //console.log(this.input);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getLists: function () {
                let optionsLists = [ {'name': 'states', 'type': 'txt'}, {'name': 'titles', 'type': 'txt'} ];
                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        let arrLists = res.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'states') this.states = arrLists[l].list
                            if (arrLists[l].name == 'titles') this.titles = arrLists[l].list
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            changeLogin: async function () {
                try {
                    this.$refs.login_credentials.validate();
                    
                    if ( this.input.password == undefined || this.input.confirm_password == undefined 
                         || this.input.password != this.input.confirm_password 
                         || this.input.password.length < 14 ) {

                        let password_error_msg = 'Both Password and Confirm Password must be submitted to change your password'
                        if ( this.input.password != this.input.confirm_password ) password_error_msg = 'Both Password and Confirm Password must be the same.'
                        if ( this.input.password.length < 14 ) password_error_msg = 'Password must be at least 14 characters long.'

                        this.actionDialog = true;
                        this.actionColor = 'error';
                        this.actionMessage = password_error_msg;
                        return
                    }
                    
                    const change_password_res = await axios.put(`${appUrls.api}/api/change_login/${Cookie.get('id')}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        password: this.input.password, 
                        confirm_password: this.input.confirm_password,
                        lockout_value: this.lockout_value
                    })

                    if ( change_password_res.data.outcome ) {
                        // console.log(change_password_res.data);
                        this.actionDialog = true;
                        this.actionColor = 'success';
                        this.actionMessage = change_password_res.data.message;
                    } else {
                        // console.log(change_password_res.data);
                        this.actionDialog = true;
                        this.actionColor = 'error';
                        this.actionMessage = change_password_res.data.message;
                    }
                } catch ( err ) {
                    consoe.log(err)
                }
            },

            updateContact: function () {
                this.$refs.contact_info.validate();
                if(this.contact_valid) {    
                    axios.put(`${appUrls.api}/api/update_contact/${Cookie.get('id')}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        first_name: this.input.first_name, 
                        last_name: this.input.last_name, 
                        phone: this.input.phone, 
                        address: this.input.address, 
                        address2: this.input.address2, 
                        city: this.input.city, 
                        state: this.input.state, 
                        postal: this.input.postal,
                        title: this.input.title,
                        website: this.input.website,
                        company: this.input.company
                    })
                    .then( res => {
                        this.actionDialog = true;
                        this.actionColor = 'success';
                        this.actionMessage = res.data.message;
                    })
                    .catch( res => {
                        this.actionDialog = true;
                        this.actionMessage = res.message;
                    });
                }
            },

            updateEmail: function () {
                this.$refs.email_username.validate();
                if(this.email_valid) {    
                    axios.put(`${appUrls.api}/api/update_email_username/${Cookie.get('id')}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        user_email: this.input.user_email
                    })
                    .then( res => {
                        this.actionDialog = true;
                        this.actionColor = 'success';
                        this.actionMessage = res.data.message;
                    })
                    .catch( res => {
                        this.actionDialog = true;
                        this.actionMessage = res.message;
                    });
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2, h3 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
    label {
        display: block;
    }
    #account {
        min-height: 70vh;
        margin-top: 10px;
    }
    #main_wrapper {
        margin: 30px 0;
    }
    #main_panel {
        width: 62%;
        /* border: 1px dotted #ccc; */
    }
    #right_panel {
        width: 38%;
        text-align: right;
        /* border: 1px dotted #ccc; */
    }
    .spacing {
        display: flex; 
        flex-direction: row; 
        justify-content: space-between;
    }
    .submit_btn {
        font-size: .8rem !important;
    }
    .subtitle_size {
        font-size: 1.2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Account.vue